import { getFirebaseBackend } from '../../authUtils.js'
import { Auth } from 'portalba360'

export const state = {
    currentUser: sessionStorage.getItem('authUser'),
    status: !!JSON.parse(localStorage.getItem('status')),
    auth: new Auth(),
    one: {},
    contacto: {}
}

export const mutations = {
    SET_CURRENT_USER(state, newValue) {
        state.currentUser = newValue
        saveState('auth.currentUser', newValue)
    },
    /**
     * funciones que asignan valores de un usuario valido,
     * las variables quedan guardades en sessionStorage localstorage.
     */
    setStatus(state, value) {
        if (typeof value === 'boolean') {
            state.status = value
            localStorage.setItem('status', value)
        } else {
            localStorage.removeItem('status')
        }
    },
    setOne: (state, data) => {
        state.one = data
    },
    setContacto: (state, data) => {
        if (data) {
            state.contacto = data
        } else {
            if (!state.status) {
                state.contacto = {}
            } else {
                state.contacto = state.auth.one('contacto')
            }
        }
    }
}

export const getters = {

    status: state => state.status,
    contacto: state => state.contacto,
    userAvatarName: state => (state.contacto.email[0] && state.contacto.nombre && state.contacto.apellido ? state.contacto.nombre[0] + state.contacto.apellido[0] : ''),
    homePage: () => {
        return { name: 'mis casos' }
    },
    one: state => state.one,
    // Whether the user is currently logged in.
    loggedIn(state) {
        return !!state.currentUser
    }
}

export const actions = {
    // This is automatically run in `src/state/store.js` when the app
    // starts, along with any other actions named `init` in other modules.
    // eslint-disable-next-line no-unused-vars
    init({ state, dispatch }) {
        dispatch('validate')
    },

    // Logs in the current user.
    logIn({ dispatch, getters }, { email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')
        return getFirebaseBackend().loginUser(email, password).then((response) => {
            const user = response
            //commit('SET_CURRENT_USER', user)
            return user
        });
    },
    async logInMitta({ commit, dispatch, getters }, value = {}) {
        commit('setLoading', 1, { root: true })
        if (getters.loggedIn) return dispatch('validate')
        let data = {
            "company": value.company,
            "email": value.email,
            "pass": value.pass,
            "url": value.url
        }
        const token = new Buffer.from(`${value.company}/${value.email}:${value.pass || 'anonymous'}`).toString('base64');
        localStorage.setItem('ba_token', token);
        let user = {
            "email": "",
            "username": ""
        }
        try {
            const response = await state.auth.login(data)
            if (response != undefined) {
                if (response.data.contacto) {
                    user.email = response.data.contacto.email[0]
                    user.username = response.data.contacto.nombre + ' ' + response.data.contacto.apellido
                    commit('setContacto', state.auth.one('contacto'))
                    commit('setLoading', -1, { root: true })
                    commit('setStatus', true);
                    commit('SET_CURRENT_USER', user)
                    user.status = 200;
                    return user;
                }
            } else {
                let err = {};
                err.message = "error";
                err.status = 403;
                return err
            }
            const token = new Buffer.from(`${value.company}/${value.contacto.email}:${value.contacto.pass || 'anonymous'}`).toString('base64');
            localStorage.setItem('ba_token', token);
        } catch (error) {
            commit('setLoading', -1, { root: true })
            //dispatch('logout')
            return (error)
        }
    },

    async saveContact({ commit, state }, contact) {
        try {
            const response = await state.auth.upd(contact);
            return response.data;
        } catch (error) {
            commit('setLoading', -1, { root: true });
        }
    },

    async updatePassword({ commit, state }, passwords) {
        try {
            const response = await state.auth.updPass(passwords);
            return response.data;
        } catch (error) {
            commit('setLoading', -1, { root: true });
        }
    },

    // Logs out the current user.
    logOut() {
        //commit('SET_CURRENT_USER', null)
        return new Promise((resolve, reject) => {
            // eslint-disable-next-line no-unused-vars
            getFirebaseBackend().logout().then((response) => {
                resolve(true);
            }).catch((error) => {
                reject(this._handleError(error));
            })
        });
    },

    logOutMitta({ commit }) {
        try {
            commit('SET_CURRENT_USER', null)
            commit('setStatus', false)
            return Promise.resolve(true)
        } catch (error) {
            return Promise.reject(error)
        }
    },

    // register the user
    register({ commit, dispatch, getters }, { email, password } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().registerUser(email, password).then((response) => {
            const user = response
            commit('SET_CURRENT_USER', user)
            return user
        });
    },

    // register the user
    // eslint-disable-next-line no-unused-vars
    resetPassword({ dispatch, getters }, { email } = {}) {
        if (getters.loggedIn) return dispatch('validate')

        return getFirebaseBackend().forgetPassword(email).then((response) => {
            const message = response.data
            return message
        });
    },

    // Validates the current user's token and refreshes it
    // with new data from the API.
    // eslint-disable-next-line no-unused-vars
    validate({ state }) {
        if (!state.currentUser) return Promise.resolve(null)
        const user = getFirebaseBackend().getAuthenticatedUser();
        //commit('SET_CURRENT_USER', user)
        return user;
    },

    async getBy({ commit, state }, data) {
        commit('setLoading', 1, { root: true })
        try {
            let response = await state.auth.getBy(data)
            commit('setLoading', -1, { root: true })
            commit('setOne', response.data[0])
        } catch (e) {
            commit('setLoading', -1, { root: true })
            return Promise.reject(e.response.data)
        }
    }
}

// ===
// Private helpers
// ===

function saveState(key, state) {
    window.localStorage.setItem(key, JSON.stringify(state))
}
